import React, {useMemo, useState} from "react";
import {
    Autocomplete,
    Box,
    Button,
    Dialog,
    DialogTitle,
    IconButton,
    MenuItem,
    Select,
    TextField,
    Typography,
} from "@mui/material";
import {DataGrid, GridColDef} from "@mui/x-data-grid";
import {MRT_ColumnFiltersState, MRT_PaginationState, MRT_SortingState,} from "material-react-table";
import {useGetAllMonitorPianAtt, useGetAllMonitorPianAttVsTimeReport, useGetAllMonitorTimeReport,} from "./Services";
import MonitorTimeReportTable from "./MonitorTimeReportTable";
import MonitorPianAttTable from "./MonitorPianAttTable";
import CloseIcon from "@mui/icons-material/Close";
import {useGetDropProgettiByRef} from "../../common/Services";


interface ListaMonitorTimeReportProps {
  // propflgtemp: string;
}

const ListaMonitorRisorse: React.FC<ListaMonitorTimeReportProps> = () => {
  const isIframe = window.self !== window.top;
  const [columnFilters, setColumnFilters] = useState<MRT_ColumnFiltersState>([],);
  const [sorting, setSorting] = useState<MRT_SortingState>([]);
  const [pagination, setPagination] = useState<MRT_PaginationState>({pageIndex: 0, pageSize: 15, });

  const [globalFilter, setGlobalFilter] = useState("");

const today = new Date();

const [viewMode, setViewMode] = useState<"TIME" | "PIAN" | "PIANVSTIME">("PIAN");

const isTimeReport = viewMode === "TIME";
const isPianAtt = viewMode === "PIAN";
const isPianAttVsTimeReport = viewMode === "PIANVSTIME";

const [anno, setAnno] = useState(today.getFullYear());
const [mese, setMese] = useState(today.getMonth() + 1);
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedCell, setSelectedCell] = useState<any>(null);

  const daysInMonth = new Date(anno, mese, 0).getDate();
const mesi = [  "Gennaio", "Febbraio", "Marzo", "Aprile",  "Maggio", "Giugno", "Luglio", "Agosto",  "Settembre", "Ottobre", "Novembre", "Dicembre"];

const [selectedProgetto, setSelectedProgetto] = useState("");

const {  data: ProgettiApiResponse,  isLoading: isLoadingProgetti,} = useGetDropProgettiByRef();

const progetti = (ProgettiApiResponse?.results ?? []) as Array<{  idprog: string;  desprog: string;}>;

  // ----------------------
  // Inject filters (ANNO / MESE)
  // ----------------------
  const effectiveFilters = useMemo(() => {
    return [
      ...columnFilters,
      { id: "anno", value: anno },
      { id: "mese", value: mese },

    ];
  }, [columnFilters, anno, mese]);

  // ----------------------
  // API CALL
  // ----------------------
const timeReportQuery = useGetAllMonitorTimeReport(
  pagination,
  effectiveFilters,
  globalFilter,
  sorting
);

const pianAttQuery = useGetAllMonitorPianAtt(
  pagination,
  effectiveFilters,
  globalFilter,
  sorting
);

const pianAttVsTimeReportQuery = useGetAllMonitorPianAttVsTimeReport(
  pagination,
  effectiveFilters,
  globalFilter,
  sorting
);


const data =
  isTimeReport ? timeReportQuery.data :
  isPianAtt ? pianAttQuery.data :
  pianAttVsTimeReportQuery.data;

const isLoading =
  isTimeReport ? timeReportQuery.isLoading :
  isPianAtt ? pianAttQuery.isLoading :
  pianAttVsTimeReportQuery.isLoading;

  // ----------------------
// Columns
// ----------------------
const generateColumns = (): GridColDef[] => {
  const cols: GridColDef[] = [
    {
      field: "coddip",
      headerName: "",
      width: 170,

      renderCell: (params) => {
        return (
          <span style={{ fontSize: "12px" }}>
            <span style={{ fontWeight: "bold",  marginRight: 4 }}>
              {params.row.coddip}
            </span>
            <span style={{ fontSize: "12px", color: "#666" }}>
              {params.row.nomedip}
            </span>
          </span>
        );
      },
    }
];

  for (let i = 1; i <= daysInMonth; i++) {
    const date = new Date(anno, mese - 1, i);
    const isWeekend = date.getDay() === 0 || date.getDay() === 6;

   cols.push({
  field: `day_${i}`,
  headerName: `${i}`,
  width: 45,
  minWidth: 40,
  headerAlign: "center",
  align: "center",

             renderCell: (params) => {
              const rawValue = params.value ?? "";
              const value = isPianAttVsTimeReport ? String(rawValue) : Number(rawValue);

              return (
                <span
                  style={{
                    display: "block",
                    width: "100%",
                    textAlign: "center",
                    fontSize: isPianAttVsTimeReport ? "11px" : "13px",
                  }}
                >
                  {value === 0 || value === "" || value === "0/0" ? "" : value}
                </span>
              );
            },

             cellClassName: (params) => {
                  const rawValue = params.value ?? "";
                  const classes: string[] = [];

                  if (isWeekend) classes.push("weekend-cell");

                  if (isPianAttVsTimeReport) {
                    const hasValue = rawValue !== "" && rawValue !== "0/0";

                     const [pian, time] = String(rawValue).split("/").map((v) => Number(v));
                     const isLow =    hasValue && !Number.isNaN(pian) && !Number.isNaN(time) && pian > time;
                     const isHigh =    hasValue && !Number.isNaN(pian) && !Number.isNaN(time) && pian < time;


                    if (hasValue) classes.push("highlight-cell");
                    if (hasValue) classes.push("clickable-cell");
                     if (isLow && time !== 0) classes.push("low-cell");
                    if (isHigh && time !== 0) classes.push("high-cell");

                    return classes.join(" ");
                  }

                  if (isPianAtt || isTimeReport) {
                    const numericValue = Number(rawValue);
                    const hasValue = numericValue > 0;

                    if (hasValue) classes.push("highlight-cell");
                    if (hasValue) classes.push("clickable-cell");
                    if (hasValue && numericValue < 4) classes.push("low-cell");
                    if (isPianAtt && numericValue > 8) { classes.push("over8-cell");
  }

                    return classes.join(" ");
                  }

                  return "";
                },

});
  }

  return cols;
};

// Pivot


const pivotData = (data: any[]) => {
  // ==========================================
  // PIAN VS TIME:
  // prima aggrego per dipendente/giorno/progetto
  // ==========================================
  if (isPianAttVsTimeReport) {
    const projectMap: Record<
      string,
      {
        coddip: string;
        nomedip: string;
        tipodip: string;
        giorno: number;
        idprog: string;
        pian: number;
        time: number;
      }
    > = {};

    data.forEach((item) => {
      const coddip = String(item.coddip || "N/D").trim();
      const giorno = Number(item.ggmese);
      const idprog = String(item.idprog ?? item.codprog ?? "NO_PROG");

      const projectKey = `${coddip}|${giorno}|${idprog}`;

      const rawValue = String(
        item.orepianattvstimereport ?? "0/0"
      );

      const [pianRaw = "0", timeRaw = "0"] = rawValue.split("/");

      const pian =
        parseFloat(pianRaw.replace(",", ".")) || 0;

      const time =
        parseFloat(timeRaw.replace(",", ".")) || 0;

      if (!projectMap[projectKey]) {
        projectMap[projectKey] = {
          coddip,
          nomedip: item.nomedip,
          tipodip: item.tipodip,
          giorno,
          idprog,

          // la pianificazione del progetto viene presa UNA volta
          pian,

          // i time report invece vanno sommati
          time,
        };
      } else {
        // NON sommare nuovamente il pian
        // perché è il totale del progetto ripetuto dal backend

        projectMap[projectKey].time += time;
      }
    });

    // ==========================================
    // secondo passaggio:
    // sommo i vari progetti per dipendente/giorno
    // ==========================================
    const map: Record<string, any> = {};

    Object.values(projectMap).forEach((item) => {
      const key = item.coddip;
      const dayKey = `day_${item.giorno}`;

      if (!map[key]) {
        map[key] = {
          id: key,
          coddip: key,
          nomedip: item.nomedip,
          tipodip: item.tipodip,
        };

        for (let i = 1; i <= 31; i++) {
          map[key][`day_${i}`] = "0/0";
        }
      }

      const current = String(map[key][dayKey] ?? "0/0");

      const [currentPianRaw = "0", currentTimeRaw = "0"] =
        current.split("/");

      const currentPian =
        parseFloat(currentPianRaw) || 0;

      const currentTime =
        parseFloat(currentTimeRaw) || 0;

      const totalPian = currentPian + item.pian;
      const totalTime = currentTime + item.time;

      map[key][dayKey] = `${totalPian}/${totalTime}`;
    });

    return Object.values(map).sort((a: any, b: any) =>
      String(a.nomedip || "").localeCompare(
        String(b.nomedip || ""),
        "it"
      )
    );
  }

  // ==========================================
  // TIME / PIAN normali
  // ==========================================
  const map: Record<string, any> = {};

  data.forEach((item) => {
    const key = String(item.coddip || "N/D").trim();
    const dayKey = `day_${item.ggmese}`;

    if (!map[key]) {
      map[key] = {
        id: key,
        coddip: key,
        nomedip: item.nomedip,
        tipodip: item.tipodip,
      };

      for (let i = 1; i <= 31; i++) {
        map[key][`day_${i}`] = 0;
      }
    }

    if (isTimeReport) {
      const value =
        parseFloat(String(item.oreeff ?? 0).replace(",", ".")) || 0;

      map[key][dayKey] += value;
    }

    if (isPianAtt) {
      const value =
        parseFloat(String(item.orepianatt ?? 0).replace(",", ".")) || 0;

      map[key][dayKey] += value;
    }
  });

  return Object.values(map).sort((a: any, b: any) =>
    String(a.nomedip || "").localeCompare(
      String(b.nomedip || ""),
      "it"
    )
  );
};



  // ----------------------
  // Pivot rows
  // ----------------------
const rows = useMemo(() => {
  if (!data?.results) return [];

  return pivotData(data.results);
}, [data, viewMode]);

const rowsInterni = useMemo(
  () => rows.filter((r) => r.tipodip === "INT"),
  [rows]
);

const rowsEsterni = useMemo(
  () => rows.filter((r) => r.tipodip === "EXT"),
  [rows]
);

const columns = useMemo(() => generateColumns(), [anno, mese, daysInMonth, viewMode]);


const getNomeMese = (mese: number) => {
  const nome = new Date(2026, mese - 1).toLocaleString("it-IT", {
    month: "long",
  });
  return nome.charAt(0).toUpperCase() + nome.slice(1);
};

// DATAGRID

const RenderGrid = ({ rows }: { rows: any[] }) => (
  <DataGrid
    rows={rows}
    columns={columns}
    loading={isLoading}
    disableColumnMenu
    disableColumnFilter
    disableColumnSelector
    disableDensitySelector
    disableRowSelectionOnClick
    disableColumnSorting
    disableColumnResize
    checkboxSelection={false}
    isCellEditable={() => false}
    hideFooter
    density="compact"
    getRowId={(row) => row.coddip}
    rowHeight={30}
    columnHeaderHeight={30}
 onCellClick={(params) => {
  if (!params.field.startsWith("day_")) return;

  const rawValue = params.value ?? "";

  const hasValue = isPianAttVsTimeReport
    ? rawValue !== "" && rawValue !== "0/0"
    : Number(rawValue) > 0;

  if (!hasValue) return;

  const day = params.field.replace("day_", "");

  setSelectedCell({
    coddip: params.row.coddip,
    day,
    mese,
    anno,
    nomedip: params.row.nomedip,
  });

  setOpenDialog(true);
}}
   sx={{
     height: "100%",
     backgroundColor: isIframe ? "#fff" : undefined,
     // === GRID LINES ===
     "& .MuiDataGrid-cell": {borderRight: "1px solid #e0e0e0", borderBottom: "1px solid #e0e0e0",padding: isPianAttVsTimeReport ? "0px" : undefined,},
     "& .MuiDataGrid-columnHeaders": {borderBottom: "1px solid #bdbdbd",},
     "& .MuiDataGrid-columnHeader": {borderRight: "1px solid #e0e0e0",},
     // optional outer border
     border: "1px solid #bdbdbd",
     // === WEEKEND HEADER ===
     "& .weekend-header, & .weekend-header *": {backgroundColor: "#eeeeee !important",},
     // === WEEKEND CELLS ===
     "& .MuiDataGrid-row .MuiDataGrid-cell.weekend-cell": {backgroundColor: "#eeeeee !important",},
     "& .MuiDataGrid-row:hover .MuiDataGrid-cell.weekend-cell": {backgroundColor: "#eeeeee !important",},

     // === VALUE CELLS ===
     "& .highlight-cell": {color: "#1976d2", fontWeight: "bold",},
     "& .weekend-cell.highlight-cell": {backgroundColor: "#e0e0e0 !important",},
     "& .low-cell": {color: "#d32f2f", fontWeight: "bold",},
     "& .high-cell": {color: "#174f10", fontWeight: "bold",},
     "& .over8-cell": {backgroundColor: "#f8d7da !important",  color: "#d32f2f",  fontWeight: "bold",},
     // weekend + low value
     "& .weekend-cell.low-cell": {backgroundColor: "#f8d7da !important",},
     "& .clickable-cell": {cursor: "pointer",},
   }}
  />
);


  // ----------------------
  // UI
  // ----------------------
return (
  <Box
    sx={{
      mt: "60px",
      height: isIframe ? "100vh" : "calc(100vh - 60px)",
      display: "flex",
      flexDirection: "column",
      boxSizing: "border-box",
      backgroundColor: isIframe ? "#fff" : undefined,
      overflow: isIframe ? "hidden" : undefined,
    }}
  >

    {/* FILTERS + NAVIGATION */}
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        mb: 1,
        gap: 6,
        flexWrap: "wrap",
        flexShrink: 0,
        backgroundColor: isIframe ? "#fff" : undefined,
      }}
    >

      {/* YEAR + MONTH */}
      <Box sx={{ display: "flex", gap: 1 }}>
        <Select
          value={anno}
          onChange={(e) => setAnno(Number(e.target.value))}
          size="small"
          sx={{ minWidth: 160 }}
        >
          {[2020, 2021, 2022, 2023, 2024, 2025, 2026].map((y) => (
            <MenuItem key={y} value={y}>
              {y}
            </MenuItem>
          ))}
        </Select>

        <Select
          value={mese}
          onChange={(e) => setMese(Number(e.target.value))}
          size="small"
          sx={{ minWidth: 160 }}
        >
          {mesi.map((nome, index) => (
            <MenuItem key={index + 1} value={index + 1}>
              {nome}
            </MenuItem>
          ))}
        </Select>

      <Autocomplete
                  options={progetti}
                  value={
                    progetti.find(
                      (progetto) => String(progetto.idprog) === selectedProgetto
                    ) ?? null
                  }
                  onChange={(_, progetto) => {
                    const idprog = progetto ? String(progetto.idprog) : "";

                    setSelectedProgetto(idprog);

                    setColumnFilters((prev) => {
                      // rimuove l'eventuale filtro progetto già presente
                      const filters = prev.filter((filter) => filter.id !== "idprog");

                      // se è stato selezionato un progetto aggiunge il filtro
                      return idprog
                        ? [...filters, { id: "idprog", value: idprog }]
                        : filters;
                    });

                    setPagination((prev) => ({
                      ...prev,
                      pageIndex: 0,
                    }));

                    setOpenDialog(false);
                  }}
                  getOptionLabel={(progetto) => progetto.desprog}
                  isOptionEqualToValue={(option, value) =>
                    String(option.idprog) === String(value.idprog)
                  }
                  loading={isLoadingProgetti}
                  loadingText="Caricamento progetti..."
                  noOptionsText="Nessun progetto trovato"
                  sx={{ minWidth: 400 }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Progetto"
                      placeholder="Tutti i progetti"
                      size="small"
                    />
                  )}
                />
      </Box>

      {/* NAVIGATION BUTTONS */}
      <Box
        sx={{
          display: "flex",
          gap: 1,
          ml: 12,
        }}
      >

                   <Button
                      variant={isPianAtt ? "contained" : "outlined"}
                      onClick={() => setViewMode("PIAN")}
                      sx={{ minWidth: 160 }}
                    >
                      Pianificazione
                    </Button>



                <Button
                      variant={isTimeReport ? "contained" : "outlined"}
                      onClick={() => setViewMode("TIME")}
                      sx={{ minWidth: 160 }}
                    >
                      Time Report
                    </Button>


                    <Button
                      variant={isPianAttVsTimeReport ? "contained" : "outlined"}
                      onClick={() => setViewMode("PIANVSTIME")}
                      sx={{ minWidth: 160 }}
                    >
                      Pian vs Time
                    </Button>
      </Box>

    </Box>

    {/* GRID */}
    <Box
      sx={{
        height: isIframe ? "auto" : "75vh",
        flex: isIframe ? 1 : undefined,
        minHeight: 0,
        width: "100%",
        display: "flex",
        flexDirection: "column",
        gap: 4,
        overflowY: isIframe ? "auto" : undefined,
        backgroundColor: isIframe ? "#fff" : undefined,
      }}
    >

      <Box
        sx={{
          flex: 1,
          minHeight: 0,
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Typography variant="subtitle2">
          INTERNI
        </Typography>

        <Box sx={{ flex: 1, minHeight: 0 }}>
          <RenderGrid rows={rowsInterni} />
        </Box>
      </Box>

      <Box
        sx={{
          flex: 1,
          minHeight: 0,
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Typography variant="subtitle2">
          ESTERNI
        </Typography>

        <Box sx={{ flex: 1, minHeight: 0 }}>
          <RenderGrid rows={rowsEsterni} />
        </Box>
      </Box>

    </Box>


{isTimeReport && (
  <Dialog
    open={openDialog}
    onClose={() => setOpenDialog(false)}
    maxWidth="lg"
    fullWidth
  >
    <DialogTitle sx={{ m: 0, p: 1 }}>
      Time Report

      <IconButton
        aria-label="close"
        onClick={() => setOpenDialog(false)}
        sx={{
          position: "absolute",
          right: 8,
          top: 8,
        }}
      >
        <CloseIcon />
      </IconButton>
    </DialogTitle>

    <MonitorTimeReportTable data={selectedCell} />
  </Dialog>
)}

{isPianAtt && (
  <Dialog
    open={openDialog}
    onClose={() => setOpenDialog(false)}
    maxWidth="lg"
    fullWidth
  >
    <DialogTitle sx={{ m: 0, p: 1 }}>
      Pian.Att.

      <IconButton
        aria-label="close"
        onClick={() => setOpenDialog(false)}
        sx={{
          position: "absolute",
          right: 8,
          top: 8,
        }}
      >
        <CloseIcon />
      </IconButton>
    </DialogTitle>

    <MonitorPianAttTable data={selectedCell} />
  </Dialog>
)}



{isPianAttVsTimeReport && (
  <Dialog
    open={openDialog}
    onClose={() => setOpenDialog(false)}
    maxWidth="lg"
    fullWidth
  >
    <DialogTitle sx={{ m: 0, p: 1 }}>
      Pian.Att.

      <IconButton
        aria-label="close"
        onClick={() => setOpenDialog(false)}
        sx={{
          position: "absolute",
          right: 8,
          top: 8,
        }}
      >
        <CloseIcon />
      </IconButton>
    </DialogTitle>
    <MonitorPianAttTable data={selectedCell} />
      <DialogTitle sx={{ m: 0, p: 1 }}>
      Time Report

      <IconButton
        aria-label="close"
        onClick={() => setOpenDialog(false)}
        sx={{
          position: "absolute",
          right: 8,
          top: 8,
        }}
      >
        <CloseIcon />
      </IconButton>
    </DialogTitle>
    <MonitorTimeReportTable data={selectedCell} />
  </Dialog>
)}


  </Box>
);


}

export default ListaMonitorRisorse;
